import { Md5 } from 'ts-md5';
export const createGravatar = async (email: string) => {
  const normalized = email?.trim().toLowerCase() ?? '';
  const hash = Md5.hashStr(normalized);
  const hashHex = hash.slice(0, 6);
  const gravatarLink = await fetch(`https://www.gravatar.com/avatar/${hash}?d=404`);
  return gravatarLink.status === 200
    ? { url: gravatarLink.url, color: null, email }
    : { url: null, color: hashHex, email };
};
